export const abcSupplierReport = {
	title: "Informe ABC de Proveedores",
	label: "ABC de Proveedores",
	description:
		"Este informe clasifica los proveedores en tres categorías (A, B, C) con base en el volumen de compras. Los proveedores de la categoría A son los que concentran la mayor parte de los gastos en compras de producto, mientras que los de la categoría C son aquellos con menor gasto.",
	export: "Descargar en Excel",
	contentTable: {
		emptyReports: "No hay informes disponibles",
		totalizers: {
			totalValues: "Valores totales de los productos",
			curveA: "Curva A",
			curveB: "Curva B",
			curveC: "Curva C",
			tooltips: {
				curveA:
					"Proveedores con alto valor que corresponden hasta el 80% del valor de las compras",
				curveB:
					"Proveedores con valor intermedio que corresponden hasta el 15% del valor de las compras",
				curveC:
					"Proveedores con bajo valor que corresponden hasta el 5% del valor de las compras",
			},
		},
		columns: {
			name: "Proveedor",
			total: "Costo Total",
			cumulateTotal: "Total Acumulado",
			percentage: "Representación Individual",
			cumulativePercentage: "Representación Acumulada",
			tier: "Clasificación",
		},
	},
};
